import { createGlobalState } from 'react-hooks-global-state';
export const { useGlobalState, setGlobalState, getGlobalState } = createGlobalState({forceLogin:false,showModalLogin:false, isLoggedIn:false, onLogin:null});
export default useGlobalState;
